import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import { useIsMount } from '@/common/hooks/use-is-mounted';
import Icon from '@/common/components/icon/icon';
import Button from '@/common/components/button/button';
import ButtonLoaderSvg from './button-loader-svg';

const ButtonLoader = ({
    loading,
    loadedText,
    fullOpacityOnLoading,
    children,
    allowShowCheckOnLoad = true,
    loadingDuration = '3s',
    className,
    ...rest
}) => {
    const isMounted = useIsMount();
    const [intervalFc, setIntervalFc] = useState(null);
    const [showCheck, setShowCheck] = useState(false);

    useEffect(() => {
        if (!allowShowCheckOnLoad) {
            return;
        }

        if (isMounted && !loading) {
            setShowCheck(true);
            setIntervalFc(
                setTimeout(() => {
                    setShowCheck(false);
                }, 2000)
            );
        }

        return () => {
            clearTimeout(intervalFc);
            setShowCheck(false);
        };
    }, [loading]);

    return (
        <Button
            className={cx('button-loader', className, {
                'full-opacity': fullOpacityOnLoading && loading,
            })}
            style={{ '--loading-animation-duration': `${loadingDuration}` }}
            {...rest}
        >
            {allowShowCheckOnLoad && showCheck && (
                <span className="button-loader__checked-text">
                    <Icon name="check" size={12} />
                    {loadedText}
                </span>
            )}
            {loading && <ButtonLoaderSvg />}
            {!showCheck && !loading && children}
        </Button>
    );
};

export default ButtonLoader;
